import { Formik, FormikHelpers, FormikProps } from 'formik';
import { toast } from 'react-toastify';
import { Form, Select } from 'formik-antd';
import { useNavigate } from 'react-router-dom';
import { BackButton, Button, ProfileDropdown } from 'components';
import { InputText } from 'components/inputs-formik';
import { createTrainingCategory } from 'store/training-categories';
import { useAppDispatch } from 'utils/hooks';
import { HTMLButtonTypes } from 'utils/enums/button-types';
import { UserLevels } from 'utils/enums/user-level';
import { userLevels } from 'utils/constants/user-levels';
import { addCategoryValidationSchema } from 'utils/validation/schemes';
import { arrowDownPurple } from 'assets/images';
import './AddTrainingCategory.scss';

const AddTrainingCategory = (): JSX.Element => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	type FormValues = {
		title?: string;
		level: UserLevels;
	};

	const initialValues: FormValues = {
		level: UserLevels.GOAL_GETTER_I,
	};

	const handleSubmit = async ({ level, title }: FormValues,
		{ setSubmitting }: FormikHelpers<FormValues>) => {
		if (!isNaN(level) && title) {
			const body = { title, level };

			try {
				await dispatch(createTrainingCategory(body)).unwrap();
				toast.success('Success!');
				navigate('/content/trainings/manage-categories');
			} catch {
				toast.error('Failed!');
			}
			setSubmitting(false);
		}
	};

	const InnerForm = ({ dirty, isValid, isSubmitting }: FormikProps<FormValues>): JSX.Element => (
		<Form className="add-category__form">
			<InputText name="title" placeholder="Enter category title" />
			<div className="add-category__form-footer">
				<Select
					className="level"
					name="level"
					placeholder="Level"
					suffixIcon={<img alt="" src={arrowDownPurple} />}
				>
					{Object.entries(userLevels).map(([key, value]) => (
						<Select.Option key={value} value={value}>
							{key}
						</Select.Option>
					))}
				</Select>
				<Button
					className="btn-purple"
					disabled={!dirty || !isValid || isSubmitting}
					htmlType={HTMLButtonTypes.SUBMIT}
					text="Submit"
				/>
			</div>
		</Form>
	);

	return (
		<div className="add-category">
			<div className="row header">
				<ProfileDropdown />
			</div>

			<div className="container">
				<div className="page-title">
					<BackButton />
					<h1>Add training category</h1>
				</div>
				<div className="add-category__wrap">
					<Formik
						component={InnerForm}
						enableReinitialize={true}
						initialValues={initialValues}
						onSubmit={handleSubmit}
						validationSchema={addCategoryValidationSchema}
					/>
				</div>
			</div>
		</div>
	);
};

export { AddTrainingCategory };
